export default __webpack_public_path__ + "static/tongue-0c9f5e90c78cbdf4cf2f6d95bbe73932.svg";